<template>
    <div>
        <DCard
            :title="__('tools.direct_admin.title')"
            class="mb-3"
            padding
        >
            <div v-if="hasActivePopulateProcesses === false || hasActiveRefreshProcesses === false">
                <DFormRow
                    :label="__('tools.direct_admin.populate')"
                    :hint="__('tools.direct_admin.populate_hint')"
                    class="mb-0"
                >
                    <DSwitch
                        id="populate"
                        v-model="form.populate"
                        color="success"
                        variant="3d"
                        :disabled="hasActivePopulateProcesses === true"
                        :checked="form.populate"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('tools.direct_admin.refresh')"
                    :hint="__('tools.direct_admin.refresh_hint')"
                    class="mb-0"
                >
                    <DSwitch
                        id="refresh"
                        v-model="form.refresh"
                        color="success"
                        variant="3d"
                        :disabled="hasActiveRefreshProcesses === true"
                        :checked="form.refresh"
                    />
                </DFormRow>
            </div>
            <DAlert
                v-else
                color="warning"
            >
                {{ __('tools.direct_admin.process_in_progress') }}
            </DAlert>
            <DFabs>
                <DFab
                    id="btn-populate-refresh"
                    icon="content-save"
                    :label="__('tools.direct_admin.populate_refresh')"
                    :disabled="hasActivePopulateProcesses === true && hasActiveRefreshProcesses === true"
                    @click="submit"
                />
            </DFabs>
        </DCard>

        <DCard
            :title="__('tools.direct_admin.history')"
            padding
        >
            <DTable
                :items="history.items"
                :fields="fields"
            >
                <template #action="{item}">
                    <td>
                        {{ __('tools.direct_admin.history_table.actions.' + item.action) }}
                    </td>
                </template>
                <template #status="{item}">
                    <td>
                        <DTag
                            v-if="item.status === 'failed'"
                            color="danger"
                            :label="__('tools.direct_admin.history_table.statuses.' + item.status)"
                        />
                        <DTag
                            v-else-if="item.status === 'completed'"
                            color="success"
                            :label="__('tools.direct_admin.history_table.statuses.' + item.status)"
                        />
                        <DTag
                            v-else
                            color="primary"
                            :label="__('tools.direct_admin.history_table.statuses.' + item.status)"
                        />
                    </td>
                </template>
                <template #errors="{item}">
                    <td>
                        {{ item.errors.length }}
                    </td>
                </template>
                <template #actions="{item}">
                    <td>
                        <DButton
                            v-if="item.errors.length > 0"
                            :id="`eye_button_${item.id}`"
                            icon="eye"
                            mini
                            @click="showErrors(item.errors)"
                        />
                    </td>
                </template>
            </DTable>
            <DPagination
                v-if="history.last_page > 1"
                class="pb-2"
                :active-page="history.current_page"
                :pages="history.last_page"
                align="center"
                @update:activePage="changePage"
            />
        </DCard>
        <HistoryErrorsModal
            v-if="showHistoryErrorModal === true"
            :show-modal="showHistoryErrorModal === true"
            :errors="errorsData"
            @close-modal="showHistoryErrorModal = false"
        />
    </div>
</template>

<script setup>
import { router, useForm } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import { ref } from 'vue'
import { __ } from '~@/Composables/translation'
import HistoryErrorsModal from '~@/Components/Tools/DirectAdmin/HistoryErrorsModal'

defineProps({
    hasActivePopulateProcesses: {
        type: Boolean,
        default: () => {
            return false
        }
    },
    hasActiveRefreshProcesses: {
        type: Boolean,
        default: () => {
            return false
        }
    },
    lastSync: {
        type: String,
        default: () => {
            return ''
        }
    },
    history: {
        type: Array,
        default: () => {
            return []
        }
    }
})

const form = useForm({
    refresh: false,
    populate: false
})

const fields = ref([
    { key: 'action', label: __('tools.direct_admin.history_table.action') },
    { key: 'status', label: __('tools.direct_admin.history_table.status') },
    { key: 'start_date', label: __('tools.direct_admin.history_table.start_date') },
    { key: 'end_date', label: __('tools.direct_admin.history_table.end_date') },
    { key: 'errors', label: __('tools.direct_admin.history_table.errors') },
    { key: 'actions', label: '', _classes: 'text-right', filter: false }
])

const showHistoryErrorModal = ref(false)
const errorsData = ref([])

function showErrors (errors) {
    errorsData.value = errors
    showHistoryErrorModal.value = true
}

function submit () {
    form.post(
        route('tools.direct-admin.store', {
            refresh: form.refresh,
            populate: form.populate
        }),
        {
            onSuccess: () => {
                form.refresh = false
                form.populate = false
            }
        }
    )
}

function changePage (page) {
    router.get(route('tools.direct-admin.index', {
        _query: {
            page: page
        }
    }))
}
</script>

<style scoped>

</style>
